const normalize = (value: string): string =>
  (value || "").replace(/\s+/g, " ").trim();

export const storefrontProductImageAlt = (
  productName: string,
  currentAlt: string,
  position: number
): string => {
  if (normalize(currentAlt)) {
    return currentAlt;
  }
  const name = normalize(productName) || "Product";
  return position <= 1 ? name : `${name} - alternate view ${position}`;
};
